import { render, staticRenderFns } from "./WeightScaleWithSelfie.vue?vue&type=template&id=307833f7&lang=pug&"
import script from "./WeightScaleWithSelfie.vue?vue&type=script&lang=js&"
export * from "./WeightScaleWithSelfie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports